import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";
import Routing from "../../../../Routing.ts";
import {Link} from "react-router-dom";

const questions: Question[] = [
    {
        question: "Ønsker du en tidligere dato?",
        answer: <>
            <p>
                Vi vil altid prøve at ændre datoen, men vi kan desværre ikke garantere, at det kan lade sig gøre.
            </p>
            <ul className="list list--bullet">
                <p>
                    Nogle af årsagerne til at det ikke er muligt kan være:
                </p>
                <li><p>
                    Der er ventetid på teknikeren, som skal koble din nye forbindelse til centralen.
                </p></li>
                <li><p>
                    Du skal have fiber, men fiberen er ikke etableret i dit område endnu.
                </p></li>
                <li><p>
                    En tidligere lejer på din adresse har haft internet, og det abonnement er ikke opsagt endnu.
                </p></li>
            </ul>
            <p><strong>
                Hvis du ønsker en tidligere dato, skal du ringe til os eller henvende dig på vores chat.
                Find kontaktoplysningerne <Link to={Routing.Contact.Index}>her</Link>.
            </strong></p>
        </>
    },
    {
        question: "Ønsker du en senere dato?",
        answer: <>
            <p>
                Hvis du kontakter os i god tid, kan vi ofte ændre til en senere dato.
                Skal du have besøg af en tekniker på din online dato, skal du kontakte os minimum 48 timer før besøget, så vi kan nå at ændre datoen.
            </p>
            <p><strong>
                Hvis du ønsker en senere dato, skal du ringe til os eller henvende dig på vores chat.
                Find kontaktoplysningerne <Link to={Routing.Contact.Index}>her</Link>.
            </strong></p>
        </>
    },
]

export default function NyOnlineDatoArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Hvis du er blevet forhindret i at være hjemme eller ønsker en ny dato, end den du tidligere har modtaget, så skal du kontakte os.
                            Så finder vi sammen en ny dato til dig.
                        </p>
                        <p>
                            Vi bestræber os altid på at ændre til den dato, du ønsker.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "leveringstid",
                        "name": "Leveringstid på internet"
                    },
                    {
                        "category": "bestilling",
                        "article": "opsig-eksisterende-abonnement",
                        "name": "Skal jeg selv opsige mit eksisterende abonnement?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "skift-navn-og-kode-paa-wifi",
                        "name": "Skift navn og kode på wifi"
                    }
                ]}
            />
        </>
    )
}
